import { getFontFacesCss, determineFontFacesFontDisplay } from '@wix/thunderbolt-becky-root'
import { Component, FontLoadStrategy } from '@wix/thunderbolt-becky-types'
import { envRefs, themeRefs } from '@wix/thunderbolt-catharsis'
import { createCssCompNode } from '../cssCompNode'
import { FeatureRefs } from '../cssFeatures.types'

export const fontFacesCss = (isEditor: boolean) => {
	return createCssCompNode('fontFaces', 'fontFacesCss', {
		getDependencies: (component: Component, refs: FeatureRefs<'fontFaces'>) => ({
			fontFaces: refs.fontFamilies(component),
			publicTopology: envRefs.publicTopology,
			fontLoadStrategyExperiment: envRefs.experiment('specs.thunderbolt.fontFacesFontDisplay'),
			wixSitesFontDisplaySwapExperiment: envRefs.experiment('specs.thunderbolt.wixSitesFontDisplaySwap'),
			isWixSite: envRefs.isWixSite,
			siteFontDisplay: themeRefs.siteFontDisplay,
		}),
		toViewItem: (
			__,
			{
				fontFaces,
				publicTopology: { mediaRootUrl },
				fontLoadStrategyExperiment,
				wixSitesFontDisplaySwapExperiment,
				isWixSite,
				siteFontDisplay,
			}
		) => {
			const fontDisplay = determineFontFacesFontDisplay({
				isEditor,
				isWixSite,
				wixSitesFontDisplaySwapExperiment: !!wixSitesFontDisplaySwapExperiment,
				fontLoadStrategyExperiment: fontLoadStrategyExperiment as FontLoadStrategy,
				siteFontDisplay,
			})
			return Array.from(fontFaces).map((fontFamily) =>
				getFontFacesCss([fontFamily], mediaRootUrl, fontDisplay as FontLoadStrategy)
			)
		},
	})
}
